const env = {
  APP_NAME: import.meta.env.VITE_APP_NAME ?? 'Bloodhound Admin',
  API_URL: import.meta.env.VITE_API_URL ?? '',
  WEB_APP_URL: import.meta.env.VITE_WEB_APP_URL ?? 'https://app.bloodhoundapp.com',
  ENV: import.meta.env.VITE_ENV ?? 'development',
  VERSION: import.meta.env.VITE_VERSION ?? '0.1.0',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  MODE: import.meta.env.MODE,
};

export default env;
